export default function ServiceCard({ name, description, image }: { name: string; description: string; image: string }) {
  return (
    <article className="overflow-hidden rounded-3xl border border-slate-200 bg-white shadow-sm transition hover:-translate-y-1 hover:shadow-lg">
      <img src={image} alt={name} className="h-52 w-full object-cover" />
      <div className="p-6">
        <h3 className="text-xl font-black text-slate-900">{name}</h3>
        <p className="mt-3 text-sm leading-7 text-slate-600">{description}</p>
      </div>
    </article>
  );
}
